/**
 * Single source of truth for GoVans.ie social links.
 */
export const SOCIAL_LINKS = {
  instagram: "https://www.instagram.com/govans.ie?igsh=M3l2cmVvZHYzOGJ1&utm_source=qr",
  facebook: "https://www.facebook.com/share/1CprtcDPvZ/?mibextid=wwXIfr",
  whatsapp: "https://wa.me/353874199541",
  phone: "tel:+353874199541",
  email: "mailto:info@govans.ie",
  googleReview: "https://maps.app.goo.gl/z3aZDGowkqnnBQ9S8?g_st=ic",
};
